// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2626n","buttons":"RemoveExpirationActionButtons_buttons__2YbX8"};